import React, {createContext, useContext, useEffect, useState} from 'react'
import CommonService from '../../../app/modules/common/core/_requests'
import {setFeatureConfig} from '../CommonHelpers'
import {PostHogService} from '../PostHogService'
import {FEATURES} from '../../constants/_features'

type FeatureConfigContextModel = {
  features: Record<string, boolean> | null
  isFeatureEnabled: (feature: string) => boolean
}

const FeatureConfigContext = createContext<FeatureConfigContextModel>({
  features: null,
  isFeatureEnabled: (feature: string) => true,
})

const FeatureConfigProvider: React.FC<{children: React.ReactNode}> = ({children}) => {
  const [features, setFeatures] = useState<Record<string, boolean> | null>(null)

  useEffect(() => {
    const load = async () => {
      try {
        const response = await CommonService.getConfigFeature()
        if (response?.features) {
          setFeatureConfig(response.features)
          setFeatures(response.features)

          if (response.features[FEATURES.POSTHOG] === true) {
            PostHogService.getInstance().init()
          }
        }
      } catch {
        setFeatures({})
      }
    }
    load()
  }, [])

  const isFeatureEnabled = (feature: string) => {
    return features?.[feature] ?? true
  }

  const value: FeatureConfigContextModel = {
    features,
    isFeatureEnabled,
  }

  return <FeatureConfigContext.Provider value={value}>{children}</FeatureConfigContext.Provider>
}

function useFeatureEnabled(feature: string): boolean {
  const {isFeatureEnabled} = useContext(FeatureConfigContext)
  return isFeatureEnabled(feature)
}

export {FeatureConfigProvider, useFeatureEnabled}
